import { render } from "./PlanningIsGood.vue?vue&type=template&id=33b48cec&scoped=true"
const script = {}

import "./PlanningIsGood.vue?vue&type=style&index=0&id=33b48cec&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b48cec"]])

export default __exports__